import type { FC } from 'react';
import { useCallback, useEffect } from 'react';
import { usePopupState } from 'material-ui-popup-state/hooks';
import { useFormContext } from 'react-hook-form';
import { useNavigate } from 'react-router';
import useRouteBlocker from '../../hooks/useBlocker';
import LeaveWithoutSavingDialog from './LeaveWithoutSavingDialog';

const ConfirmationDialog: FC<{ isUnblock?: boolean }> = ({ isUnblock }) => {
  const navigate = useNavigate();
  const {
    formState: { isDirty },
  } = useFormContext();
  const popupState = usePopupState({
    variant: 'dialog',
    popupId: 'ConfirmationDialog',
  });

  const { nextPathname, onBlockRoute, onUnblockRoute, routeBlocker } =
    useRouteBlocker({ callback: popupState.open });

  const handleStayOnPage = useCallback(() => {
    popupState.close();
  }, [popupState]);

  const handleLeavePage = useCallback(() => {
    popupState.close();
    onUnblockRoute();
    if (routeBlocker.state === 'blocked' && routeBlocker.proceed) {
      routeBlocker.proceed();
    } else if (nextPathname && !isUnblock) {
      navigate(nextPathname, { replace: true });
    }
  }, [
    nextPathname,
    routeBlocker,
    navigate,
    onUnblockRoute,
    popupState,
    isUnblock,
  ]);

  useEffect(() => {
    if (isUnblock) {
      if (routeBlocker.state === 'blocked' && routeBlocker.proceed) {
        routeBlocker.proceed();
      }
      return;
    }
    isDirty ? onBlockRoute() : onUnblockRoute(); // Block navigation if form is dirty
  }, [isDirty, isUnblock, routeBlocker, onBlockRoute, onUnblockRoute]);

  if (isUnblock) return null;

  return (
    <LeaveWithoutSavingDialog
      open={popupState.isOpen}
      onStay={handleStayOnPage}
      onLeave={handleLeavePage}
    />
  );
};

export default ConfirmationDialog;
